export default {
  // ========== GradeTableRanges ==========
  selectedRange: 'Selected range:',
  gradeRanges: 'Grade ranges',
  colors: 'Colors',
  color: 'Color',
}
